<script lang="ts">
  import { pauseWhenOffscreen } from '../actions';
  function go(id: string) {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }
</script>

<section class="hero" id="top">
  <div class="hero__core wrap">
    <div>
      <svg class="ouro" viewBox="0 0 240 240" id="ouro" role="img" aria-label="Уроборос — четыре стадии Делания">
        <g class="ouro__spin" use:pauseWhenOffscreen>
          <circle class="scales" cx="120" cy="120" r="92" stroke="var(--mercury)" />
          <path class="seg" d="M120,28 A92,92 0 0,1 212,120" stroke="var(--nigredo)" />
          <path class="seg" d="M212,120 A92,92 0 0,1 120,212" stroke="var(--albedo)" />
          <path class="seg" d="M120,212 A92,92 0 0,1 28,120" stroke="var(--citrinitas)" />
          <path class="seg" d="M28,120 A92,92 0 0,1 113,28.3" stroke="var(--rubedo)" />
          <path d="M113,28.3 l9,-5 l-2,9 z" fill="var(--rubedo)" filter="url(#glow)" />
          <circle cx="120" cy="28" r="2.6" fill="var(--void)" stroke="var(--rubedo)" stroke-width="1.4" />
        </g>
        <g
          class="ouro__node"
          role="button"
          tabindex="0"
          aria-label="Карта I, Nigredo"
          onclick={() => go('reg-1')}
          onkeydown={(e) => e.key === 'Enter' || e.key === ' ' ? (e.preventDefault(), go('reg-1')) : null}
        >
          <circle cx="206" cy="74" r="5.5" fill="var(--nigredo)" filter="url(#glow)" />
          <text x="206" y="62">I</text>
        </g>
        <g
          class="ouro__node"
          role="button"
          tabindex="0"
          aria-label="Карта II, Albedo"
          onclick={() => go('reg-2')}
          onkeydown={(e) => e.key === 'Enter' || e.key === ' ' ? (e.preventDefault(), go('reg-2')) : null}
        >
          <circle cx="206" cy="166" r="5.5" fill="var(--albedo)" filter="url(#glow)" />
          <text x="206" y="186">II</text>
        </g>
        <g
          class="ouro__node"
          role="button"
          tabindex="0"
          aria-label="Карта III, Citrinitas"
          onclick={() => go('reg-3')}
          onkeydown={(e) => e.key === 'Enter' || e.key === ' ' ? (e.preventDefault(), go('reg-3')) : null}
        >
          <circle cx="34" cy="166" r="5.5" fill="var(--citrinitas)" filter="url(#glow)" />
          <text x="34" y="186">III</text>
        </g>
        <g
          class="ouro__node"
          role="button"
          tabindex="0"
          aria-label="Карта IV, Rubedo"
          onclick={() => go('reg-4')}
          onkeydown={(e) => e.key === 'Enter' || e.key === ' ' ? (e.preventDefault(), go('reg-4')) : null}
        >
          <circle cx="34" cy="74" r="5.5" fill="var(--rubedo)" filter="url(#glow)" />
          <text x="34" y="62">IV</text>
        </g>
      </svg>
      <h1 class="hero__title">Гримуар <em>способностей</em></h1>
      <p class="hero__sub">
        Четыре карты — четыре стадии Делания: от тела на полу до существа за линией возможного.
        Сквозь все четыре течёт <i>Меркурий</i> — одна способность, перерождающаяся на каждом уровне.
        Войди в стадию через кольцо или коснись любого узла, чтобы раскрыть его.
      </p>
    </div>
  </div>
  <div class="hero__foot">
    <div class="mono">Opus Magnum · I → IV</div>
    <a class="scrollcue" href="#legend" aria-label="Вниз">↓</a>
  </div>
</section>
